module.exports = __webpack_public_path__ + "static/logo4-494d9333a7d6b0593bbd8c994a343d19.png";